








































import {Component, Vue} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import Card from '@c/Card.vue';
import Loading from '@c/controls/Loading.vue';
import {getDateWithTime} from '@/utils/dateTimeUtils';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import PModuleButtons from './PModuleButtons.vue';
import bearingtasksStoreModule from '@/store/modules/bearingtasksModule';
import bearingsStoreModule from '@/store/modules/bearingsModule';

@Component({
  components: {
    Card,
    Loading,
    PModuleButtons,
  },
})
export default class BearingJournal extends Vue {
  // Программный модуль
  pmodule: PModuleWithMeasurements | null = null;

  // Показатели загрузки данных и ошибки
  loading = true;
  error = false;

  bearings: any[] = [];
  event_ts = '';

  bearingHeaders: DataTableHeader[] = [
    {
      text: 'Частота',
      value: 'frequency_name',
      sortable: false,
    },
    {
      text: 'Амплитуда в автоспектре, дБ(А)',
      value: 'value_auto',
      sortable: false,
    },
    {
      text: 'Амплитуда в спектре огибающей',
      value: 'value_envelope',
      sortable: false,
    },
  ];

  async created() {
    try {
      const {data} = await bearingtasksStoreModule.getById(this.$attrs.id);
      this.pmodule = data as PModuleWithMeasurements;
      if (!this.pmodule) return;
      await bearingsStoreModule.fetchAll();

      const bearings: any[] = [];

      const records = await bearingtasksStoreModule.getLastEvents({
        id: this.pmodule.id as number,
        eventType: 'bearing_data',
        limit: 10,
      });
      const headers: {[key: string]: number} = {};
      records[1].forEach((val: any, index: number) => {
        headers[val[0]] = index;
      });

      records[0].forEach((ev: any) => {
        if (!this.event_ts) this.event_ts = '(' + getDateWithTime(ev[headers['timestamp']]) + ')';
        JSON.parse(ev[headers['bearings']]).forEach((b: any) => {
          if (!bearings[b.id]) {
            bearings[b.id] = {
              id: b.id,
              name: bearingsStoreModule.all.find(item => item.id == b.id)?.name,
              rot_frequency: [],
              cage_frequency: [],
              inner_ring: [],
              outer_ring: [],
              roller_frequency: [],
              data: [],
            };
          }
          if (ev[headers['spectrum_type']] == 0) {
            bearings[b.id]['rot_frequency'][0] = Math.max(
              Math.max(...b.rot.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['rot_frequency'][0] ?? 0,
            );
            bearings[b.id]['cage_frequency'][0] = Math.max(
              Math.max(...b.cage.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['cage_frequency'][0] ?? 0,
            );
            bearings[b.id]['inner_ring'][0] = Math.max(
              Math.max(...b.inner.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['inner_ring'][0] ?? 0,
            );
            bearings[b.id]['outer_ring'][0] = Math.max(
              Math.max(...b.outer.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['outer_ring'][0] ?? 0,
            );
            bearings[b.id]['roller_frequency'][0] = Math.max(
              Math.max(...b.roller.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['roller_frequency'][0] ?? 0,
            );
          } else {
            bearings[b.id]['rot_frequency'][ev[headers['central_frequency']]] = Math.max(
              Math.max(...b.rot.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['rot_frequency'][ev[headers['central_frequency']]] ?? 0,
            );
            bearings[b.id]['cage_frequency'][ev[headers['central_frequency']]] = Math.max(
              Math.max(...b.cage.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['cage_frequency'][ev[headers['central_frequency']]] ?? 0,
            );
            bearings[b.id]['inner_ring'][ev[headers['central_frequency']]] = Math.max(
              Math.max(...b.inner.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['inner_ring'][ev[headers['central_frequency']]] ?? 0,
            );
            bearings[b.id]['outer_ring'][ev[headers['central_frequency']]] = Math.max(
              Math.max(...b.outer.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['outer_ring'][ev[headers['central_frequency']]] ?? 0,
            );
            bearings[b.id]['roller_frequency'][ev[headers['central_frequency']]] = Math.max(
              Math.max(...b.roller.map((f: any) => f[1]).filter((v: number) => v < 1e4)),
              bearings[b.id]['roller_frequency'][ev[headers['central_frequency']]] ?? 0,
            );
          }
        });
      });
      bearings.forEach((b: any) => {
        b.rot_frequency.forEach((val: number, index: number) => {
          if (index == 0)
            b.data.push({
              frequency_name: 'Fвр',
              value_auto: val.toFixed(4),
              value_envelope: '',
            });
          else
            b.data.push({
              frequency_name: '',
              value_auto: '',
              value_envelope: `${val.toFixed(4)} на ${index} Гц`,
            });
        });
        b.rot_frequency = null;
        b.cage_frequency.forEach((val: number, index: number) => {
          if (index == 0)
            b.data.push({
              frequency_name: 'сепаратор',
              value_auto: val.toFixed(4),
              value_envelope: '',
            });
          else
            b.data.push({
              frequency_name: '',
              value_auto: '',
              value_envelope: `${val.toFixed(4)} на ${index} Гц`,
            });
        });
        b.cage_frequency = null;
        b.inner_ring.forEach((val: number, index: number) => {
          if (index == 0)
            b.data.push({
              frequency_name: 'внутреннее кольцо',
              value_auto: val.toFixed(4),
              value_envelope: '',
            });
          else
            b.data.push({
              frequency_name: '',
              value_auto: '',
              value_envelope: `${val.toFixed(4)} на ${index} Гц`,
            });
        });
        b.inner_ring = null;
        b.outer_ring.forEach((val: number, index: number) => {
          if (index == 0)
            b.data.push({
              frequency_name: 'внешнее кольцо',
              value_auto: val.toFixed(4),
              value_envelope: '',
            });
          else
            b.data.push({
              frequency_name: '',
              value_auto: '',
              value_envelope: `${val.toFixed(4)} на ${index} Гц`,
            });
        });
        b.outer_ring = null;
        b.roller_frequency.forEach((val: number, index: number) => {
          if (index == 0)
            b.data.push({
              frequency_name: 'тела качения',
              value_auto: val.toFixed(4),
              value_envelope: '',
            });
          else
            b.data.push({
              frequency_name: '',
              value_auto: '',
              value_envelope: `${val.toFixed(4)} на ${index} Гц`,
            });
        });
        b.roller_frequency = null;
        this.bearings.push(b);
      });
    } catch (errorData) {
      if (Vue.config.devtools) {
        // печатаем ошибку в режиме разработки
        console.error(errorData);
      }
      this.error = true;
    } finally {
      this.loading = false;
    }
  }
}
